import type { SVGProps } from 'react';

type ConfigureDashboardIconProps = SVGProps<SVGSVGElement>;

/** Figma 4092:39309 — 96×96 gear, stroke 3. */
export function ConfigureGearIcon({
  width = 96,
  height = 96,
  className,
  ...props
}: ConfigureDashboardIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M48 60C54.6276 60 60 54.6276 60 48C60 41.3724 54.6276 36 48 36C41.3724 36 36 41.3724 36 48C36 54.6276 41.3724 60 48 60Z"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.4896 41.5816L74.0988 30.9792L80 24L72 16L65.0588 21.9318L54.2312 17.479L51.7412 8H43.924L41.3964 17.6045L30.8176 22.0638L24 16L16 24L21.8135 31.1554L17.49 41.7852L8 44V52L17.6044 54.622L22.063 65.1988L16 72L24 80L31.1646 74.1612L41.588 78.4492L44 88H52L54.418 78.4528L65.0204 74.062C66.7876 75.3252 72 80 72 80L80 72L74.0636 64.9976L78.4556 54.392L87.9996 51.9088L88 44L78.4896 41.5816Z"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Figma 4092:39318 — 32×32 agent face. */
export function ConfigureCreateAgentIcon({
  width = 32,
  height = 32,
  className,
  ...props
}: ConfigureDashboardIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M4 21.3333V10.6667C4 6.98477 6.98477 4 10.6667 4H21.3333C25.0152 4 28 6.98477 28 10.6667V21.3333C28 25.0152 25.0152 28 21.3333 28H10.6667C6.98477 28 4 25.0152 4 21.3333Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M22 19.332C22 19.332 20 21.9987 16 21.9987C12 21.9987 10 19.332 10 19.332"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3346 13.3333C10.9664 13.3333 10.668 13.0349 10.668 12.6667C10.668 12.2985 10.9664 12 11.3346 12C11.7028 12 12.0013 12.2985 12.0013 12.6667C12.0013 13.0349 11.7028 13.3333 11.3346 13.3333Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6667 13.3333C20.2985 13.3333 20 13.0349 20 12.6667C20 12.2985 20.2985 12 20.6667 12C21.0348 12 21.3333 12.2985 21.3333 12.6667C21.3333 13.0349 21.0348 13.3333 20.6667 13.3333Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Figma 4092:39328 — 32×32 three stars. */
export function ConfigureCreateSkillsIcon({
  width = 32,
  height = 32,
  className,
  ...props
}: ConfigureDashboardIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M6.18123 19.2201L7.56658 16.2828C7.74442 15.9057 8.25818 15.9057 8.43602 16.2828L9.82137 19.2201L12.9194 19.6941C13.3169 19.7549 13.4753 20.2663 13.1876 20.5597L10.9462 22.8445L11.4752 26.0724C11.5431 26.4869 11.1274 26.8029 10.7717 26.6072L8.0013 25.0824L5.23089 26.6072C4.87522 26.8029 4.45947 26.4869 4.52741 26.0724L5.05637 22.8445L2.81503 20.5597C2.52726 20.2663 2.68569 19.7549 3.08318 19.6941L6.18123 19.2201Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1811 19.2201L23.5666 16.2828C23.7443 15.9057 24.2582 15.9057 24.4359 16.2828L25.8214 19.2201L28.9194 19.6941C29.3169 19.7549 29.4753 20.2663 29.1875 20.5597L26.9462 22.8445L27.4751 26.0724C27.5431 26.4869 27.1274 26.8029 26.7717 26.6072L24.0013 25.0824L21.2309 26.6072C20.8751 26.8029 20.4594 26.4869 20.5274 26.0724L21.0563 22.8445L18.815 20.5597C18.5273 20.2663 18.6857 19.7549 19.0831 19.6941L22.1811 19.2201Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1812 7.2202L15.5666 4.28281C15.7444 3.90573 16.2582 3.90573 16.436 4.28281L17.8214 7.2202L20.9194 7.69413C21.3169 7.75493 21.4753 8.26632 21.1876 8.55968L18.9462 10.8445L19.4752 14.0724C19.5432 14.4869 19.1274 14.8029 18.7717 14.6072L16.0013 13.0824L13.2309 14.6072C12.8752 14.8029 12.4595 14.4869 12.5274 14.0724L13.0564 10.8445L10.815 8.55968C10.5273 8.26632 10.6857 7.75493 11.0832 7.69413L14.1812 7.2202Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Figma 4092:39337 — 32×32 cube with bandage. */
export function ConfigureConnectAppsIcon({
  width = 32,
  height = 32,
  className,
  ...props
}: ConfigureDashboardIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M16 29.3327L4.41152 22.8947C4.15755 22.7535 4.00003 22.4859 4.00003 22.1954L4 9.80347C4 9.51293 4.15752 9.24524 4.41149 9.10415L15.6115 2.88192C15.8531 2.74769 16.1469 2.74769 16.3885 2.88192L27.5885 9.10415C27.8425 9.24524 28 9.51293 28 9.80347V14.6661"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.70312 9.72419L15.61 15.7836C15.8516 15.9178 16.1455 15.9178 16.3871 15.7836L27.3319 9.70312"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 16V23.3333"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 2.66797V12.0013"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.875 22.9922L25.8178 23.935"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9883 24.875L23.9311 25.8178"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8754 19.2185L19.2185 24.8754C18.1772 25.9168 18.1772 27.6053 19.2185 28.6466L20.1613 29.5894C21.2028 30.6309 22.8912 30.6309 23.9325 29.5894L29.5894 23.9326C30.6308 22.8912 30.6308 21.2028 29.5894 20.1613L28.6466 19.2185C27.6052 18.1772 25.9168 18.1772 24.8754 19.2185Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
